import { useEffect, useMemo, useRef, useState } from "react";
import { HiDotsHorizontal } from "react-icons/hi";
import React from "react";
import { ipfsGatewayImage } from "../../utils/ipfsGatewayImage";
import { CiUser } from "react-icons/ci";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { handleClickOutside } from "../../utils/handleClickOutside";
import { setChatWith } from "../../redux/slices/communityFeedSlice";

type ChatListProps = {
  community: any;
  index: any;
};
const ChatList: React.FC<Partial<ChatListProps>> = ({
  community,
  index,
}) => {
  const [active, setActive] = useState<number | null>(null);

  const handleActive = (index: number) => {
    setActive(index);
  };
  const userID = window.localStorage.getItem("user");

  // console.log(community.id + '' + community.firstName);
  
  // const [lastActiveTime, setLastActiveTime] = React.useState(Date.now());

  // //this function is getting the last active time
  // useEffect(() => {
  //   const intervalId = setInterval(() => {
  //     setLastActiveTime((prevTime) => prevTime + 1000); // Increment by 1 second
  //   }, 1000);

  //   return () => {
  //     clearInterval(intervalId);
  //   };
  // }, []);

  // const formatActiveStatus = () => {
  //   const currentTime = Date.now();
  //   const timeDifference = currentTime - lastActiveTime;
  //   const secondsAgo = Math.floor(timeDifference / 1000);

  //   if (timeDifference < 5000) {
  //     // Less than 5 seconds ago
  //     return "Active now";
  //   } else if (secondsAgo < 60) {
  //     return `Active ${secondsAgo} seconds ago`;
  //   } else if (secondsAgo < 3600) {
  //     const minutesAgo = Math.floor(secondsAgo / 60);
  //     return `Active ${minutesAgo} minute${minutesAgo > 1 ? "s" : ""} ago`;
  //   } else if (secondsAgo < 86400) {
  //     const hoursAgo = Math.floor(secondsAgo / 3600);
  //     return `Active ${hoursAgo} hour${hoursAgo > 1 ? "s" : ""} ago`;
  //   } else if (secondsAgo < 2592000) {
  //     const daysAgo = Math.floor(secondsAgo / 86400);
  //     return `Active ${daysAgo} day${daysAgo > 1 ? "s" : ""} ago`;
  //   } else {
  //     const monthsAgo = Math.floor(secondsAgo / 2592000);
  //     return `Active ${monthsAgo} month${monthsAgo > 1 ? "s" : ""} ago`;
  //   }
  // };
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useMemo(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const dropdownLeftPosition = screenWidth > 1208 ? "155px" : "100px";

  const containerRef = useRef<HTMLDivElement>(null);

  const dispatch = useDispatch();

  const [openRequest, setOpenRequest] = React.useState(null);

  const handleToggle = (index: any) => {
    setOpenRequest((prev) => (prev === index ? null : index));
  };

  let _pImage: string | null = "";

  if (
    community?.ecobookProfile &&
    community.ecobookProfile.profileImage !== null
  ) {
    const profileImage = community?.ecobookProfile?.profileImage;

    if (profileImage !== null && profileImage !== undefined) {
      _pImage = profileImage;
    }
  }

  let chatID: any;
  if (userID && community.id) {
    if (userID.localeCompare(community.id) < 0) {
      chatID = `${userID}${community.id}`;
    } else if (userID.localeCompare(community.id) > 0) {
      chatID = `${community.id}${userID}`;
    }
  }

  const chatDetails = {
    id: chatID,
    profileImage: _pImage || null,
    name: `${community.firstName} ${community.lastName}`,
  };

  useEffect(() => {
    const removeClickOutsideListener = handleClickOutside(containerRef, () => {
      setOpenRequest(null);
    });

    return () => {
      removeClickOutsideListener();
    };
  }, []);

  return (
    <div
      className={`flex items-center justify-between pr-2 cursor-pointer ${
        active === index
          ? "bg-midGreen h-9 transition-all rounded ease-linear duration-150"
          : ""
      }`}
      key={chatDetails?.id}
      onClick={() => handleActive(index)}
      ref={containerRef}
    >
      <div className="flex h-8 justify-between gap-2 items-center">
        <div className="w-7 h-7 rounded-full">
          {_pImage ? (
            <img
              alt=""
              src={ipfsGatewayImage(_pImage)}
              className={`w-7 h-7 rounded-full ${
                active === index ? "ml-2 mb-px" : ""
              }`}
            />
          ) : (
            <div className="w-7 h-7 bg-slate-100 flex items-center justify-center rounded-full">
              <CiUser size={18} />
            </div>
          )}
        </div>
        <div className="flex flex-col justify-between relative">
          <h4
            className={`text-sm font-medium ${
              active === index ? "text-white" : "text-lightBlack"
            }`}
          >
            {`${community?.firstName} ${community.lastName}`}
          </h4>
          {/* <p
                    className={`font-normal text-[9px] ${
                      active === index ? "text-whiteMode" : "text-lightGreyText"
                    }`}
                  >
                    {formatActiveStatus()}
                  </p> */}
          {openRequest === index && (
            <div
              className="absolute top-full"
              style={{ left: dropdownLeftPosition }}
            >
              <div className="border-l-[8px] w-[10px] border-r-[8px] ml-1 border-l-transparent border-r-transparent border-b-[#000] border-b-[10px] border-solid"></div>
              <ul className="shadow bg-[#000] w-[103px] text-white mt-0 rounded whitespace-nowrap font-Poppins text-center justify-center text-xs">
                <Link to={`/chat/e/${chatID}`}>
                  <li
                    className="p-2 border-b border-solid"
                    onClick={() => dispatch(setChatWith(chatDetails))}
                  >
                    Message
                  </li>
                </Link>
              </ul>
            </div>
          )}
        </div>
      </div>
      <HiDotsHorizontal
        size={13}
        className={`${active === index ? "fill-white" : "fill-lightGreyText"} `}
        onClick={() => handleToggle(index)}
      />
    </div>
  );
};

export default ChatList;
